import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import LoginTemplateComponent from "./login-template.component";
import { setUserTokenAction } from "@reducers/app.reducer";
import service from "./login.component.service";
import { setAlertMessage, setAlert } from "@reducers/alert.reducer";
import MESSAGES from "@constants/messages.constants";
import { setFilterList } from "@reducers/filter.reducer";
import {
  hubHosted,
  fetchHubToken,
  fetchHubSession,
  hubUserShape,
} from "../../utils/hub-sso";

const {
  ALERT_TYPES: { ERROR },
} = MESSAGES;

const LoginComponent = () => {
  const [data, setData] = useState({
    username: "",
    password: "",
  });
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const { alertMessage } = useSelector((state) => state.alert);
  const app = useSelector((state) => state.app);
  const { username, password } = data;
  const [passwordVisibility, setPasswordVisibility] = useState(false);

  const handleTogglePassword = () => {
    setPasswordVisibility(!passwordVisibility);
  };

  const handleChange = (e) => {
    console.log({ e });
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    const response = await service.loginProcess(data);
    if (response.status) {
      setIsLoading(false);
      dispatch(
        setAlert({
          alert: true,
          type: "success",
          title: "Success",
          message: "Login Successfully!",
        })
      );
      dispatch(
        setUserTokenAction({ token: response.token, user: response.user })
      );

      const filterList = response.user?.filter_list || "[]";
      dispatch(setFilterList(JSON.parse(filterList)));
      history.push("/dashboard");
    } else {
      setIsLoading(false);
      dispatch(
        setAlertMessage({ type: ERROR, message: response.message, viewed: 0 })
      );
    }
  };

  const checkLoggedInUser = () => {
    if (app && app?.token) {
      history.push("/dashboard");
    }
  };

  // On the hosted domain, a signed-in Hub session walks straight in: the
  // shared cookie is exchanged for a product JWT and stored in the same slot
  // the local login uses. Any failure just leaves the local form showing.
  const tryHubSso = async () => {
    if (!hubHosted() || (app && app.token)) return;
    const token = await fetchHubToken();
    if (!token) return;
    const session = await fetchHubSession();
    dispatch(setUserTokenAction({ token, user: hubUserShape(session) }));
    history.push("/dashboard");
  };

  useEffect(() => {
    checkLoggedInUser();
    tryHubSso();
    if (app.theme === "light") {
      document.body.classList.remove("dark-layout");
      document.body.classList.add("light-layout");
    } else {
      document.body.classList.remove("light-layout");
      document.body.classList.add("dark-layout");
    }
  }, []);

  return (
    <LoginTemplateComponent
      templateModal={{
        username,
        password,
        isLoading,
        alertMessage,
        passwordVisibility,
      }}
      templateEvents={{ handleChange, handleSubmit, handleTogglePassword }}
    />
  );
};

export default LoginComponent;
